import { SeverityNumber } from "@opentelemetry/api-logs";

import {
  getBrowserTelemetryInstance,
  isBrowserTelemetryInitialized,
} from "@superblocksteam/telemetry/browser";

/**
 * Records the connection requested in a landing URL, not a verified identity
 * or completed login. Delivery is best-effort and respects export policy.
 */
export function logConnectionLinkLogin(
  connection: string | undefined,
  tree: "app" | "dashboard",
): void {
  if (!connection || !isBrowserTelemetryInitialized()) return;

  try {
    const telemetry = getBrowserTelemetryInstance();
    // Bound URL input to connection-name syntax. This is not identity validation.
    const name = /^[A-Za-z0-9_-]{1,128}$/.test(connection)
      ? connection
      : "[invalid]";
    // Emit directly once, without also passing through console capture.
    telemetry.getLogger().emit({
      severityNumber: SeverityNumber.INFO,
      body: "Redirect requested through a connection link",
      attributes: {
        "event.name": "auth.connection_link_redirect",
        "connection_link.name": name,
        "ui.tree": tree,
      },
    });
    // Start the keepalive export without waiting for the network before login.
    void telemetry.forceFlush().catch(() => undefined);
  } catch {
    // Telemetry must never prevent login, including when initialization failed.
  }
}
